(() => {
  'use strict';
  if (window.DramaStore) return;
  window.DramaStore = true;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const root = window.Shopify?.routes?.root || '/';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const currency = document.body.dataset.dramaCurrency || 'MXN';
  const money = cents => new Intl.NumberFormat('es-MX', {style:'currency', currency, maximumFractionDigits:2}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  let lastFocus, quickProduct, quickVariant, galleryIndex = 0, gallery = [];
  let cartQueue = Promise.resolve();
  let lastCart=null;
  const cartProducts=new Map();
  const dialog = id => document.getElementById(id);
  const setMessage = (element, text) => { if (element) element.textContent = text; };
  async function api(path, data) {
    const options = data === undefined ? {headers:{Accept:'application/json'}} : {
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)
    };
    const response = await fetch(root + path, options);
    const result = await response.json();
    if (!response.ok || result.status >= 400) {
      const message = result.description || result.message || 'No se pudo actualizar la bolsa. Intenta de nuevo.';
      throw new Error(typeof message === 'string' ? message : Object.values(message).flat().join(' '));
    }
    return result;
  }
  function show(id) {
    const el = dialog(id);
    if (!el || el.open) return;
    $$('.d-dialog[open]').forEach(other => other.close());
    lastFocus = document.activeElement;
    if (!el.open) el.showModal();
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('d-dialog-open');
    if (id === 'DramaSearch') setTimeout(() => $('#DramaSearchInput')?.focus(), 40);
  }
  function close(el) {
    if (!el || el.classList.contains('is-closing')) return;
    if(reduced || !el.classList.contains('d-cart-dialog')){el.close();return;}
    el.classList.add('is-closing');
    setTimeout(()=>{el.close();el.classList.remove('is-closing');},240);
  }
  function bindDialogs() {
    $$('.d-dialog').forEach(el => {
      if (el.dataset.bound) return;
      el.dataset.bound = 'true';
      el.addEventListener('click', e => {
        if (e.target !== el) return;
        const r = el.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(el);
      });
      el.addEventListener('close', () => {
        if (!$('.d-dialog[open]')) {document.documentElement.style.overflow = '';document.body.classList.remove('d-dialog-open');}
        if (lastFocus?.isConnected && !$('.d-dialog[open]')) lastFocus.focus({preventScroll:true});
      });
      el.addEventListener('cancel',e=>{e.preventDefault();close(el);});
    });
  }
  function safeCartImage(src) {
    if (!src) return '';
    try {const u = new URL(src, location.origin);if (u.protocol !== 'https:' && u.protocol !== 'http:') return '';u.searchParams.set('width','230');return u.href;} catch {return '';}
  }
  function renderCart(cart) {
    lastCart=cart;
    $$('[data-d-count]').forEach(el => el.textContent = cart.item_count);
    setMessage($('[data-d-drawer-count]'), '(' + cart.item_count + ')');
    setMessage($('[data-d-page-count]'), '(' + cart.item_count + ')');
    const pageCart=$('[data-d-cart-page]');
    if(pageCart?.dataset.dCartPageSection) updateCartPage(pageCart.dataset.dCartPageSection);
    const items = $('[data-d-cart-items]');
    if (!items) return;
    const note=$('[data-d-cart-note]');
    if(note && document.activeElement!==note)note.value=cart.note||'';
    $('[data-d-cart-summary]').hidden = cart.item_count === 0;
    setMessage($('[data-d-checkout-total]'),money(cart.total_price));
    const inCart=new Set(cart.items.map(item=>item.handle));
    $$('.d-cart-recs-track [data-d-card]').forEach(card=>{
      try {const data=JSON.parse($('[data-d-product]',card).textContent);card.hidden=inCart.has(data.url.split('/').pop().split('?')[0]);}catch{}
    });
    const recSection=$('.d-cart-recommendations');if(recSection)recSection.hidden=!$$('.d-cart-recs-track [data-d-card]').some(card=>!card.hidden);
    if(note)note.closest('details').hidden=!cart.item_count;
    if (!cart.item_count) {
      const image=dialog('DramaCart')?.dataset.emptyImage;
      items.innerHTML = `<div class="d-cart-empty">${image?`<div class="d-cart-empty__image"><img src="${escape(image)}" alt="Bad Romance de DRAMA" width="1122" height="1402"></div>`:''}<h3>Tu próximo look empieza aquí.</h3><p>Descubre las piezas de Casino Nights y Beautiful Disaster.</p><a href="${root}collections/t-shirts" class="d-button d-button--black">Explorar las playeras <svg class="d-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" aria-hidden="true"><path d="M5 19 19 5M5 5h14v14"/></svg></a></div>`;
      return;
    }
    items.innerHTML = cart.items.map((item,index) => `<div class="d-cart-item" data-key="${escape(item.key)}" data-handle="${escape(item.handle)}" data-variant="${item.variant_id||item.id}">
      <a class="d-cart-item__image" href="${escape(item.url)}"><img src="${escape(safeCartImage(item.image))}" alt="${escape(item.product_title)}" width="120" height="150"></a>
      <div class="d-cart-item__info"><div class="d-cart-item__top"><a href="${escape(item.url)}">${escape(item.product_title)}</a><strong>${money(item.final_line_price)}${item.original_line_price>item.final_line_price?`<del>${money(item.original_line_price)}</del>`:''}</strong><button type="button" class="d-cart-remove-icon" data-d-change="0" aria-label="Eliminar ${escape(item.product_title)} de la bolsa"><svg class="d-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg></button></div>
      <div class="d-cart-size-row"><span>Talla: ${escape(item.variant_title || 'Única')}</span><button type="button" data-d-edit-size aria-expanded="false" aria-controls="CartSize-${index}" aria-label="Cambiar talla de ${escape(item.product_title)}">Cambiar</button></div><div id="CartSize-${index}" class="d-cart-size-panel" data-d-size-panel hidden></div>
      <div class="d-cart-item__controls"><div class="d-cart-quantity"><button type="button" data-d-change="${item.quantity - 1}" aria-label="Quitar una unidad de ${escape(item.product_title)}"><svg class="d-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" aria-hidden="true"><path d="M5 12h14"/></svg></button><span aria-live="polite">${item.quantity}</span><button type="button" data-d-change="${item.quantity + 1}" aria-label="Agregar una unidad de ${escape(item.product_title)}"><svg class="d-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg></button></div><button class="d-cart-remove" type="button" data-d-change="0">Eliminar</button></div></div></div>`).join('');
    setMessage($('[data-d-cart-total]'), money(cart.total_price) + ' ' + cart.currency);
    const discounts = $('[data-d-cart-discounts]');
    if (discounts) discounts.innerHTML = (cart.cart_level_discount_applications || []).map(d => `<div class="d-cart-discount"><span>${escape(d.title)}</span><span>−${money(d.total_allocated_amount)}</span></div>`).join('');
  }
  let cartPageRequest=0;
  async function updateCartPage(sectionId) {
    const request=++cartPageRequest;
    try {
      const response=await fetch(root+'cart?section_id='+encodeURIComponent(sectionId));
      if(!response.ok)return;
      const html=await response.text();
      if(request!==cartPageRequest)return;
      const parsed=new DOMParser().parseFromString(html,'text/html');
      const replacement=$('[data-d-cart-page]',parsed),current=$('[data-d-cart-page]');
      if(replacement&&current)current.replaceWith(replacement);
    }catch{}
  }
  async function refreshCart() { const cart = await api('cart.js'); renderCart(cart); return cart; }
  async function openCart() {
    if(lastCart)renderCart(lastCart);
    show('DramaCart');setMessage($('[data-d-cart-status]'), '');
    try {await refreshCart();} catch (error) {setMessage($('[data-d-cart-status]'), error.message);}
  }
  async function add(id, quantity, message) {
    if (!id) throw new Error('Elige una talla para continuar.');
    setMessage(message, 'Añadiendo a tu bolsa…');
    await api('cart/add.js', {items:[{id:Number(id),quantity:Number(quantity) || 1}]});
    const cart = await refreshCart();
    setMessage(message, 'Añadido.');
    show('DramaCart');setMessage($('[data-d-cart-status]'), 'Producto añadido a tu selección.');
    setTimeout(()=>setMessage($('[data-d-cart-status]'),''),2500);
    document.dispatchEvent(new CustomEvent('drama:cart-updated',{detail:cart}));
  }
  function setCartBusy(busy) {
    const drawer=dialog('DramaCart');
    if(busy)drawer.setAttribute('aria-busy','true');else drawer.removeAttribute('aria-busy');
    $$('[data-d-change],[data-d-edit-size],[data-d-cart-size],#DramaCheckout button',drawer).forEach(control=>control.disabled=busy);
  }
  function queueChange(key, quantity) {
    const drawer = dialog('DramaCart');
    setCartBusy(true);
    setMessage($('[data-d-cart-status]'), 'Actualizando…');
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      try {const cart = await api('cart/change.js', {id:key,quantity});renderCart(cart);setMessage($('[data-d-cart-status]'), 'Bolsa actualizada.');}
      catch (error) {setMessage($('[data-d-cart-status]'), error.message);try {await refreshCart();} catch {}}
      finally {setCartBusy(false);}
    });
  }
  function getCartProduct(handle) {
    if(!cartProducts.has(handle))cartProducts.set(handle,api('products/'+encodeURIComponent(handle)+'.js').catch(error=>{cartProducts.delete(handle);throw error;}));
    return cartProducts.get(handle);
  }
  async function editCartSize(button) {
    const line=button.closest('[data-key]'),panel=$('[data-d-size-panel]',line);
    if(!panel.hidden){panel.hidden=true;button.setAttribute('aria-expanded','false');return;}
    panel.hidden=false;button.disabled=true;button.setAttribute('aria-expanded','true');
    panel.innerHTML='<p role="status">Cargando tallas…</p>';
    try{
      const product=await getCartProduct(line.dataset.handle);
      panel.innerHTML=`<select data-d-cart-size aria-label="Talla de ${escape(product.title)}">${product.variants.map(variant=>`<option value="${variant.id}" ${String(variant.id)===line.dataset.variant?'selected':''} ${variant.available?'':'disabled'}>${escape(variant.title)}${variant.available?'':' · Agotada'}</option>`).join('')}</select>`;
      $('[data-d-cart-size]',panel)?.focus();
    }catch(error){panel.innerHTML='<p role="alert">'+escape(error.message)+'</p>';}
    finally{button.disabled=false;}
  }
  function changeCartSize(select) {
    const line=select.closest('[data-key]'),key=line.dataset.key,newId=Number(select.value);
    if(!newId||newId===Number(line.dataset.variant))return;
    setCartBusy(true);select.disabled=true;
    setMessage($('[data-d-cart-status]'),'Cambiando talla…');
    cartQueue=cartQueue.catch(()=>{}).then(async()=>{
      try{
        const current=await api('cart.js'),old=current.items.find(item=>item.key===key);
        if(!old)throw new Error('La bolsa cambió. Vuelve a elegir la talla.');
        const properties=old.properties||{};
        const sameOptions=item=>JSON.stringify(item.properties||{})===JSON.stringify(properties)&&!item.selling_plan_allocation;
        const existing=current.items.find(item=>Number(item.variant_id||item.id)===newId&&sameOptions(item));
        let added;
        try{added=await api('cart/add.js',{items:[{id:newId,quantity:old.quantity,properties}]});}
        catch(error){
          // Shopify can add part of the requested stock even when it returns 422.
          // Restore the destination's original quantity before reporting failure.
          try{
            const latest=await api('cart.js');
            const partial=latest.items.find(item=>Number(item.variant_id||item.id)===newId&&sameOptions(item));
            if(partial&&partial.quantity!==(existing?.quantity||0))await api('cart/change.js',{id:partial.key,quantity:existing?.quantity||0});
          }catch{throw new Error('No se pudo completar el cambio de talla. Revisa las piezas de tu bolsa antes de pagar.');}
          throw error;
        }
        try{
          const updated=await api('cart/change.js',{id:key,quantity:0});renderCart(updated);
        }catch(error){
          try{await api('cart/change.js',{id:added.items[0].key,quantity:existing?.quantity||0});}
          catch{throw new Error('No se pudo completar el cambio de talla. Revisa las piezas de tu bolsa antes de pagar.');}
          throw error;
        }
        setMessage($('[data-d-cart-status]'),'Talla actualizada.');
      }catch(error){setMessage($('[data-d-cart-status]'),error.message);try{await refreshCart();}catch{}}
      finally{setCartBusy(false);select.disabled=false;}
    });
    return cartQueue;
  }
  function openQuick(card) {
    const data = $('[data-d-product]',card);
    if (!data) return;
    try {quickProduct = JSON.parse(data.textContent);} catch {location.href = $('a',card).href;return;}
    quickVariant = null;
    setMessage($('[data-d-quick-title]'), quickProduct.title);
    setMessage($('[data-d-quick-price]'), money(quickProduct.variants[0]?.price || 0) + ' ' + currency);
    const image = $('[data-d-quick-image]');image.src = quickProduct.image;image.alt = quickProduct.title;
    $('[data-d-quick-link]').href = quickProduct.url;
    $('[data-d-quick-add]').disabled = true;
    setMessage($('[data-d-quick-message]'), '');
    $('[data-d-quick-sizes]').innerHTML = quickProduct.variants.map(v => `<button type="button" data-d-quick-variant="${v.id}" aria-pressed="false" ${v.available ? '' : 'disabled'}>${escape(v.title)}</button>`).join('');
    show('DramaQuick');
  }
  function selectMain(button) {
    const form = button.closest('form');
    if (!form) return;
    $$('[data-d-variant]',form).forEach(b => b.setAttribute('aria-pressed',String(b === button)));
    $('[name="id"]',form).value = button.dataset.dVariant;
    $$('[data-d-main-price]').forEach(price=>setMessage(price,money(Number(button.dataset.dPrice)) + ' ' + currency));
    const available = button.dataset.available === 'true';
    form.dataset.sizeChosen='true';
    $$('[data-d-main-add]').forEach(submit=>{
      submit.disabled=!available;
      submit.innerHTML=available?'Añadir a la bolsa <svg class="d-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" aria-hidden="true"><path d="M5 19 19 5M5 5h14v14"/></svg>':'Agotado';
    });
    setMessage($('[data-d-selected-size]'),'Talla '+button.textContent.trim());
    const url = new URL(location.href);url.searchParams.set('variant',button.dataset.dVariant);history.replaceState({},'',url);
  }
  function changeScene(button) {
    const hero = button.closest('[data-d-hero]'), scene = button.dataset.dScene;
    $$('[data-d-scene]',hero).forEach(b => b.setAttribute('aria-pressed',String(b === button)));
    $$('.d-hero__photo img',hero).forEach(img => {const src = img.dataset[scene];if (src && src !== img.src) {img.style.opacity = '.45';const next = new Image();next.onload = () => {img.src = src;img.style.opacity = '1';};next.onerror = () => img.style.opacity = '1';next.src = src;}});
    setMessage($('[data-d-hero-caption]',hero), scene === 'night' ? 'Colección 01' : 'Colección 02');
    setMessage($('[data-d-hero-title]',hero),scene==='night'?'Casino Nights':'Beautiful Disaster');
    $('[data-d-hero-link]',hero).href = '/collections/' + (scene === 'night' ? 'casino-y-noche' : 'beautiful-disaster');
  }
  function railStep(button, direction) {
    const rail = button.closest('[data-d-rail]'), track = $('[data-d-track]',rail);
    if (!track) return;
    const width = track.firstElementChild?.getBoundingClientRect().width || track.clientWidth * .8;
    const end=track.scrollWidth-track.clientWidth;
    if (direction>0 && track.scrollLeft>=end-5) track.scrollTo({left:0,behavior:reduced?'auto':'smooth'});
    else if (direction<0 && track.scrollLeft<=5) track.scrollTo({left:end,behavior:reduced?'auto':'smooth'});
    else track.scrollBy({left:direction * (width + 18),behavior:reduced ? 'auto' : 'smooth'});
  }
  function setupRails() {
    $$('[data-d-rail]').forEach(rail => {
      if (rail.dataset.bound) return;rail.dataset.bound = 'true';
      const track = $('[data-d-track]',rail);
      if (!track) return;
      const update = () => {
        const max = Math.max(0,track.scrollWidth - track.clientWidth);
        const fraction = max ? track.scrollLeft / max : 0;
        const progress = $('[data-d-progress]',rail);
        if (progress) {const visible = track.clientWidth / track.scrollWidth;progress.style.width = Math.max(.08,visible) * 100 + '%';progress.style.transform = `translateX(${fraction * (1 / Math.max(.08,visible) - 1) * 100}%)`;}
        const first = track.children[0]?.getBoundingClientRect().width || 1;
        setMessage($('[data-d-position]',rail),String(Math.min(track.children.length,Math.round(track.scrollLeft / (first + 18)) + 1)).padStart(2,'0') + ' / ' + String(track.children.length).padStart(2,'0'));
      };
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',e => {if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault();track.scrollBy({left:(e.key === 'ArrowRight' ? 1 : -1)*track.clientWidth*.8,behavior:reduced?'auto':'smooth'});}});
      let down=false,startX,startScroll,moved=false;
      track.addEventListener('pointerdown',e => {if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button')) return;down=true;moved=false;startX=e.clientX;startScroll=track.scrollLeft;});
      track.addEventListener('pointermove',e => {if (!down) return;const delta=e.clientX-startX;if (Math.abs(delta)>5) {moved=true;track.style.scrollSnapType='none';track.scrollLeft=startScroll-delta;e.preventDefault();}});
      const stop=()=>{down=false;track.style.scrollSnapType='';};
      track.addEventListener('pointerup',stop);track.addEventListener('pointerleave',stop);
      track.addEventListener('click',e=>{if (moved) {e.preventDefault();e.stopPropagation();moved=false;}},true);
      track.addEventListener('dragstart',e=>e.preventDefault());update();
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(update).observe(track);
    });
  }
  function setupHero() {
    $$('[data-d-hero]').forEach(hero => {
      if (hero.dataset.bound || reduced) return;hero.dataset.bound = 'true';
      let scheduled=false,x=0,y=0;
      hero.addEventListener('pointermove',e => {if (e.pointerType !== 'mouse') return;const r=hero.getBoundingClientRect();x=(e.clientX-r.left)/r.width*2-1;y=(e.clientY-r.top)/r.height*2-1;if (!scheduled) {scheduled=true;requestAnimationFrame(()=>{hero.style.setProperty('--px',x);hero.style.setProperty('--py',y);scheduled=false;});}},{passive:true});
      hero.addEventListener('pointerleave',()=>{hero.style.setProperty('--px',0);hero.style.setProperty('--py',0);});
    });
  }
  let siteMotionBound=false;
  function setupSiteMotion() {
    if(siteMotionBound || !$('.d-header'))return;
    siteMotionBound=true;
    const wrapper=$('.page-wrapper');
    let queued=false;
    const clamp=value=>Math.max(0,Math.min(1,value));
    function update() {
      queued=false;
      const viewport=window.innerHeight;
      // Navigation remains available in both scroll directions.
      $('#header-group')?.classList.remove('d-header-hidden');
      if(!reduced){
        const hero=$('.d-hero--studio');
        if(hero){const rect=hero.getBoundingClientRect();hero.style.setProperty('--d-hero-scroll',clamp(-rect.top/Math.max(1,rect.height)).toFixed(3));}
        const footer=$('[data-d-footer]');
        if(footer){const rect=footer.getBoundingClientRect();footer.style.setProperty('--d-footer-progress',clamp((viewport-rect.top)/Math.max(1,Math.min(rect.height,viewport)*.7)).toFixed(3));}
        $$('[data-d-campaign]').forEach(section=>{const rect=section.getBoundingClientRect();section.style.setProperty('--d-campaign-progress',clamp((viewport-rect.top)/(viewport+rect.height)).toFixed(3));});
      }
    }
    const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update);}};
    window.addEventListener('scroll',schedule,{passive:true});
    wrapper?.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    update();
  }
  function openGallery(link) {
    gallery=$$('[data-d-gallery-open]').map(a=>({src:a.href,alt:$('img',a)?.alt||'DRAMA'}));
    galleryIndex=Number(link.dataset.index);renderGallery();show('DramaLightbox');
  }
  function setupProductPurchase() {
    const form=$('[data-d-product-form]'),bar=$('[data-d-product-sticky]');
    if(!form||form.dataset.purchaseBound)return;
    form.dataset.purchaseBound='true';
    const preselected=$('[data-d-variant][aria-pressed="true"]',form);
    if(preselected)selectMain(preselected);
    // Without JS the native form still submits the first available variant.
    // With JS require an explicit size choice, matching quick add behavior.
    else{
      form.dataset.sizeChosen='false';
      $$('[data-d-main-add]').forEach(button=>{button.disabled=true;button.textContent='Selecciona una talla';});
    }
    if(bar&&'IntersectionObserver' in window){
      new IntersectionObserver(entries=>entries.forEach(entry=>{
        const passed=entry.boundingClientRect.bottom<0;
        bar.classList.toggle('is-visible',!entry.isIntersecting&&passed);
        bar.setAttribute('aria-hidden',String(entry.isIntersecting||!passed));
      }),{threshold:0}).observe(form);
    }
  }
  function setupBagHandle() {
    const handle=$('.d-cart-handle'),bag=dialog('DramaCart');
    if(!handle||!bag||handle.dataset.dragBound)return;
    handle.dataset.dragBound='true';
    let origin=null,distance=0;
    handle.addEventListener('pointerdown',event=>{
      if(event.button!==0||!bag.open)return;
      origin=event.clientY;distance=0;
      handle.setPointerCapture?.(event.pointerId);
    });
    handle.addEventListener('pointermove',event=>{
      if(origin===null)return;
      distance=Math.max(0,event.clientY-origin);
      if(!reduced){bag.style.transition='none';bag.style.transform='translateY('+distance+'px)';}
    });
    const stop=()=>{
      if(origin===null)return;
      const dismiss=distance>70;
      origin=null;distance=0;bag.style.transition='';bag.style.transform='';
      if(dismiss)close(bag);
    };
    handle.addEventListener('pointerup',stop);
    handle.addEventListener('pointercancel',()=>{distance=0;stop();});
  }
  function renderGallery() {if (!gallery.length) return;const img=$('[data-d-lightbox-image]');img.src=gallery[galleryIndex].src;img.alt=gallery[galleryIndex].alt;}
  document.addEventListener('click',async e=>{
    const target=e.target.closest('button,a');if (!target) return;
    if (target.matches('[data-d-close]')) {close(target.closest('dialog'));return;}
    if (target.matches('[data-d-cart]')) {e.preventDefault();openCart();return;}
    if (target.matches('[data-d-menu]')) {show('DramaMenu');return;}
    if (target.matches('[data-d-search]')) {show('DramaSearch');return;}
    if (target.matches('[data-d-view-fit]')) {
      const photos=$$('[data-d-gallery-open]');
      if(photos.length)openGallery(photos[Number(target.dataset.dViewFit)]||photos[0]);return;
    }
    if (target.matches('[data-d-edit-size]')) {await editCartSize(target);return;}
    if (target.matches('[data-d-look-quick]')) {
      const card=$('[data-d-look-card] [data-d-card]',target.closest('[data-d-shop-look]'));
      if(card){dialog('DramaQuick').classList.add('d-quick--instant');openQuick(card);}return;
    }
    if (target.matches('[data-d-compare-to]')) {
      const range=$('[data-d-compare-range]',target.closest('[data-d-compare]'));
      if(range){range.value=target.dataset.dCompareTo;updateCompare(range);}return;
    }
    if (target.matches('[data-d-quick]')) {
      const card=target.closest('[data-d-card]');if(window.matchMedia('(hover:none)').matches || window.innerWidth<=749){dialog('DramaQuick').classList.add('d-quick--instant');openQuick(card);return;}const expanded=card.classList.toggle('is-choosing');target.setAttribute('aria-expanded',String(expanded));if(expanded)$('[data-d-inline-variant]:not(:disabled)',card)?.focus();return;
    }
    if (target.matches('[data-d-inline-variant]')) {
      const card=target.closest('[data-d-card]');if(card.dataset.busy)return;card.dataset.busy='1';card.setAttribute('aria-busy','true');target.classList.add('is-adding');target.disabled=true;
      try {await add(target.dataset.dInlineVariant,1,$('[data-d-inline-message]',card));card.classList.remove('is-choosing');$('[data-d-quick]',card)?.setAttribute('aria-expanded','false');setMessage($('[data-d-inline-message]',card),'');}
      catch(error){setMessage($('[data-d-inline-message]',card),error.message);}
      finally {card.dataset.busy='';card.removeAttribute('aria-busy');target.classList.remove('is-adding');target.disabled=false;}return;
    }
    if (target.matches('[data-d-variant]')) {selectMain(target);return;}
    if (target.matches('[data-d-scene]')) {changeScene(target);return;}
    if (target.matches('[data-d-prev]')) {railStep(target,-1);return;}
    if (target.matches('[data-d-next]')) {railStep(target,1);return;}
    if (target.matches('[data-d-change]')) {queueChange(target.closest('[data-key]').dataset.key,Number(target.dataset.dChange));return;}
    if (target.matches('[data-d-quick-variant]')) {
      quickVariant=quickProduct.variants.find(v=>String(v.id)===target.dataset.dQuickVariant);
      $$('[data-d-quick-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b===target)));
      $('[data-d-quick-add]').disabled=!quickVariant?.available;
      if(dialog('DramaQuick').classList.contains('d-quick--instant')&&quickVariant?.available){
        if(dialog('DramaQuick').dataset.busy)return;dialog('DramaQuick').dataset.busy='1';
        target.disabled=true;try{await add(quickVariant.id,1,$('[data-d-quick-message]'));}catch(error){setMessage($('[data-d-quick-message]'),error.message);}finally{target.disabled=false;dialog('DramaQuick').dataset.busy='';}
      }return;
    }
    if (target.matches('[data-d-quick-add]')) {
      target.disabled=true;
      try {await add(quickVariant?.id,1,$('[data-d-quick-message]'));} catch(error) {setMessage($('[data-d-quick-message]'),error.message);} finally {target.disabled=false;}return;
    }
    if (target.matches('[data-d-gallery-open]')) {e.preventDefault();openGallery(target);return;}
    if (target.matches('[data-d-lightbox-prev],[data-d-lightbox-next]')) {galleryIndex=(galleryIndex+(target.matches('[data-d-lightbox-next]')?1:-1)+gallery.length)%gallery.length;renderGallery();}
  });
  document.addEventListener('submit',async e=>{
    const form=e.target;if (!form.matches('.d-product-form')) return;e.preventDefault();
    if(form.dataset.sizeChosen==='false'){
      setMessage($('[data-d-form-message]',form),'Elige tu talla para continuar.');
      $('[data-d-variant]:not(:disabled)',form)?.focus();return;
    }
    const submit=$('[type="submit"]',form),data=new FormData(form);submit.disabled=true;
    $$('[data-d-main-add]').forEach(button=>button.disabled=true);
    try {await add(data.get('id'),data.get('quantity'),$('[data-d-form-message]',form));}
    catch(error) {setMessage($('[data-d-form-message]',form),error.message);}
    finally {$$('[data-d-main-add]').forEach(button=>button.disabled=false);}
  });
  document.addEventListener('change',async e=>{
    if(e.target.matches('[data-d-sort]'))e.target.form.submit();
    if(e.target.matches('[data-d-cart-size]'))await changeCartSize(e.target);
  });
  document.addEventListener('keydown',e=>{if (!dialog('DramaLightbox')?.open || !gallery.length) return;if (e.key==='ArrowLeft'||e.key==='ArrowRight') {e.preventDefault();galleryIndex=(galleryIndex+(e.key==='ArrowRight'?1:-1)+gallery.length)%gallery.length;renderGallery();}});
  let motionTimer;
  function startPageMotion(restart=false) {
    const html=document.documentElement,loader=$('#DramaTransition');
    if(!loader || document.body.dataset.dramaEditor==='true') {html.classList.remove('drama-entering','drama-leaving','is-revealing');return;}
    clearTimeout(motionTimer);
    if(reduced){html.classList.remove('drama-leaving','is-revealing');html.classList.add('drama-entering');motionTimer=setTimeout(()=>html.classList.remove('drama-entering'),350);return;}
    if(restart){html.classList.remove('drama-entering','drama-leaving','is-revealing');void loader.offsetWidth;html.classList.add('drama-entering');}
    html.classList.remove('drama-leaving');
    html.classList.add('drama-entering');
    motionTimer=setTimeout(()=>{html.classList.add('is-revealing');motionTimer=setTimeout(()=>html.classList.remove('drama-entering','is-revealing'),760);},640);
  }
  document.addEventListener('click',e=>{
    if(reduced || e.defaultPrevented || e.button!==0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)return;
    const a=e.target.closest('a[href]');if(!a || a.hasAttribute('download') || a.target&&a.target!=='_self' || a.hasAttribute('data-no-transition'))return;
    const href=a.getAttribute('href');if(!href || href.startsWith('#'))return;
    let url;try{url=new URL(a.href,location.href);}catch{return;}
    if(url.origin!==location.origin || !/^https?:$/.test(url.protocol) || /^\/(checkout|checkouts|admin|account)(?:\/|$)/.test(url.pathname))return;
    if(url.pathname===location.pathname && url.search===location.search)return;
    e.preventDefault();clearTimeout(motionTimer);
    $$('.d-dialog[open]').forEach(el=>el.close());
    document.documentElement.classList.remove('drama-entering','is-revealing');
    document.documentElement.classList.add('drama-leaving');
    setTimeout(()=>location.assign(url.href),290);
    setTimeout(()=>document.documentElement.classList.remove('drama-leaving'),2500);
  });
  let noteTimer;
  function updateCompare(range) {
    const value=Math.max(0,Math.min(100,Number(range.value)));
    range.closest('.d-piece__visual').style.setProperty('--d-compare',value+'%');
    range.setAttribute('aria-valuetext','Frente '+value+'%, espalda '+(100-value)+'%');
  }
  document.addEventListener('input',e=>{
    if(e.target.matches('[data-d-compare-range]')){updateCompare(e.target);return;}
    if(!e.target.matches('[data-d-cart-note]'))return;
    clearTimeout(noteTimer);const note=e.target.value;
    noteTimer=setTimeout(async()=>{try{await api('cart/update.js',{note});setMessage($('[data-d-note-status]'),'Nota guardada.');}catch{setMessage($('[data-d-note-status]'),'No se pudo guardar la nota.');}},500);
  });
  function init() {
    bindDialogs();setupRails();setupHero();setupSiteMotion();setupProductPurchase();setupBagHandle();
    if ('IntersectionObserver' in window && !reduced) {
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.08});
      $$('[data-d-reveal]').forEach(el=>{
        if(el.dataset.revealBound || el.closest('.d-cart-recs-track'))return;
        el.dataset.revealBound='true';
        if(el.matches('[data-d-card]')){
          const siblings=Array.from(el.parentElement.children),columns=window.innerWidth<=749?2:window.innerWidth<=1000?3:4;
          el.style.setProperty('--d-stagger',(siblings.indexOf(el)%columns)*65+'ms');
        }
        el.classList.add('d-reveal');observer.observe(el);
      });
    }
    startPageMotion();

  }
  if (document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',e=>{if(e.persisted){startPageMotion(true);refreshCart().catch(()=>{});}});
})();
